import React from 'react';
import RightSection from './RightSection';
import { UIPosition, UIUser } from 'types';
import JobDescription from './JobDescription';
import { PositionSkill } from './PositionDrawer';

interface Props {
	userDetail: UIUser;
	positionDetail: UIPosition;
	positionSkills: PositionSkill[];
}

const PositionDrawerBody = ({ positionDetail, positionSkills, userDetail }: Props) => {

	const location = Array.isArray(positionDetail?.workLocations) ? positionDetail.workLocations.map(loc => loc.split(',')[0]) : [];
	// console.log('location', location);
	const locationArray = Array.isArray(location) ? location : location ? [location] : [];
	const workLocation = positionDetail?.workLocation;
	if (workLocation && !locationArray.includes(workLocation)) {
		locationArray.push(workLocation);
	}
	let locationArrayFiltered = locationArray;
	// console.log('locationArray', locationArray);
	if (locationArray.length > 1) {
		locationArrayFiltered = locationArray.filter(loc => loc.toLowerCase() !== 'any');
	}
	let locationString = Array.from(new Set(locationArrayFiltered.map(item => item.trim()).filter(item => item))).join(' | ');
	if (locationString.includes(',')) {
		locationString = locationString.replace(/,/g, " | ");
	}
    
	locationString = Array.from(new Set(locationString.split(" | ").map(item => item.toLowerCase())))
    .map(uniqueItem => locationString.split(" | ").find(item => item.toLowerCase() === uniqueItem))
    .join(" | ");
	
	
	
	return (
		<div className="mt-[20px] flex justify-between sm:flex-col sm:justify-start">
			<div className="w-[634px] sm:w-full">
				<JobDescription
					workingMode={positionDetail?.workingMode || ''}
					workingExp={
						positionDetail?.positionRequirement.workExperience
							? `${Math.floor(positionDetail?.positionRequirement.workExperience.min)} Yrs ${
									Math.ceil(positionDetail?.positionRequirement.workExperience?.min * 12) % 12
							  } Mon - ${Math.floor(positionDetail?.positionRequirement.workExperience.max)} Yrs ${
									Math.ceil(positionDetail?.positionRequirement.workExperience?.max * 12) % 12
							  } Mon `
							: ''
					}
					minSalary={positionDetail?.salary.min || 0}
					maxSalary={positionDetail?.salary.max || 0}
					location={locationString || ''}
					jobType={positionDetail?.positionType || ''}
					description={positionDetail?.description || ''}
					minInternshipSalary={positionDetail?.internshipSalary?.min}
					maxInternshipSalary={positionDetail?.internshipSalary?.max}
					internshipDuration={positionDetail?.internshipDuration}
					hasBond={positionDetail?.hasBond}
					bondDetails={positionDetail?.bondDetails}
				/>
			</div>
			<div className="ml-[66px] w-[420px] sm:ml-0 sm:mt-6 sm:w-full">
				<RightSection positionSkills={positionSkills} position={positionDetail} userDetail={userDetail} />
			</div>
		</div>
	);
};

export default PositionDrawerBody;
